import React from 'react'
export const VideoSection = (props) => {
  const { isCreator, videoRef, isSharing } = props;
  return (
    <div className='video-section'>
      <h3>Your Screen {isCreator && '(Creator)'}</h3>
      <video
        ref={videoRef}
        autoPlay
        muted
        playsInline
        className='video-element'
      />
      {isSharing && <div className='sharing-indicator'>● Sharing</div>}
    </div>
  );
};
